import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const STRIKE_OUT_AVOID_BUTTON_WITH_ICON_HEIGHT = 120;
const ICON_SIZE = 40;
const style = () => {
    const { borderRadius3, space4 } = theme();
    return StyleSheet.create({
        button: {
            alignItems: "flex-start",
            borderRadius: borderRadius3,
            flexDirection: "column",
            justifyContent: "space-between",
            minHeight: STRIKE_OUT_AVOID_BUTTON_WITH_ICON_HEIGHT,
            paddingHorizontal: space4,
            paddingVertical: space4,
        },
        container: {
            flex: 1,
        },
        icon: {
            fontSize: ICON_SIZE,
            height: ICON_SIZE,
            lineHeight: ICON_SIZE,
            minHeight: ICON_SIZE,
            minWidth: ICON_SIZE,
            width: ICON_SIZE,
        },
        text: {
            padding: 0,
            textAlign: "left",
        },
        textChecked: {
            textDecorationLine: "line-through",
        },
    });
};
export { style };
